/**
 * Draggable marquee.
 * Turns a CSS-keyframe marquee into a native horizontal scroller that keeps
 * auto-scrolling, but yields to drag (mouse), swipe (touch) and wheel input.
 * Opt in per section with data-marquee on the viewport element; the first
 * child must be the animated track holding two identical content halves.
 */
(function () {
  if (window.__niudMarqueeDrag) return;
  window.__niudMarqueeDrag = true;

  var RESUME_DELAY = 1500;

  function init(viewport) {
    if (viewport.dataset.marqueeReady) return;
    var track = viewport.firstElementChild;
    if (!track) return;

    // Read the keyframe speed before the class below disables the animation.
    var duration = parseFloat(getComputedStyle(track).animationDuration) || 60;
    var half = 0;
    var pxPerSec = 0;

    function measure() {
      half = track.scrollWidth / 2;
      pxPerSec = half > 0 ? half / duration : 0;
    }

    viewport.dataset.marqueeReady = '1';
    viewport.classList.add('marquee-drag');
    measure();

    // Lazy images and late webfonts can change the track width after init; a
    // stale measurement of 0 would leave pxPerSec at 0 and freeze the marquee.
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(track);
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', measure, { once: true });
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = false;
    var resumeTimer = null;
    var last = null;

    // The authoritative position is kept here as a float, never read back from
    // scrollLeft: Safari rounds scrollLeft to whole pixels on some containers,
    // and sub-pixel steps would otherwise be swallowed and the marquee stall.
    var pos = 0;

    function apply() {
      if (half > 0) pos = ((pos % half) + half) % half;
      viewport.scrollLeft = pos;
    }

    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
    }

    function resumeSoon() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        last = null;
      }, RESUME_DELAY);
    }

    function tick(now) {
      requestAnimationFrame(tick);
      if (paused || reduced || document.hidden) {
        last = now;
        return;
      }
      if (half <= 0) {
        measure();
        return;
      }
      if (last === null) last = now;
      var dt = (now - last) / 1000;
      last = now;
      if (dt > 0.5) return; // tab was backgrounded; skip the jump
      pos += pxPerSec * dt;
      apply();
    }
    requestAnimationFrame(tick);

    var dragging = false;
    var startX = 0;
    var startPos = 0;

    viewport.addEventListener('pointerdown', function (e) {
      pause();
      if (e.pointerType === 'touch') return; // native touch scrolling handles it
      dragging = true;
      startX = e.clientX;
      startPos = pos;
      viewport.classList.add('is-grabbing');
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      pos = startPos - (e.clientX - startX);
      apply();
      e.preventDefault();
    });

    function endDrag(e) {
      if (dragging) {
        dragging = false;
        viewport.classList.remove('is-grabbing');
        try {
          if (e && e.pointerId != null && viewport.hasPointerCapture(e.pointerId)) {
            viewport.releasePointerCapture(e.pointerId);
          }
        } catch (err) {}
      }
      resumeSoon();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('wheel', function () {
      pause();
      resumeSoon();
    }, { passive: true });

    // Native touch/wheel scrolling moves scrollLeft behind our back: adopt the
    // new position, and wrap backwards only while the visitor is driving.
    viewport.addEventListener('scroll', function () {
      if (half <= 0) return;
      if (Math.abs(viewport.scrollLeft - pos) < 2) return; // our own write
      pos = viewport.scrollLeft;
      if (pos >= half) { pos -= half; viewport.scrollLeft = pos; }
      else if (paused && pos <= 0) { pos += half; viewport.scrollLeft = pos; }
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-marquee]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
